export default [
    {
        path: '/datev-account/document-account-statement/:datevAccount?',
        name: 'document_account_statement',
        component: () => import('@src/datev-account/datev-account.vue'),
        meta: {
            title: 'Kontoauszug Belege',
            role: 'ROLE_ACCOUNT_STATEMENT',
        },
        props(route: any) {
            return {
                datevAccount: route.params.datevAccount,
                mode: 'document',
            };
        },
    },
    {
        path: '/datev-account/document-branch-account-statement/:datevAccount?',
        name: 'document_branch_account_statement',
        component: () => import('@src/datev-account/datev-account.vue'),
        meta: {
            title: 'Kontoauszug Vorgänge',
            role: 'ROLE_ACCOUNT_STATEMENT',
        },
        props(route: any) {
            return {
                datevAccount: route.params.datevAccount,
                mode: 'documentBranch',
            };
        },
    },
];
